interface IconProps extends React.SVGProps<SVGSVGElement> {}

export const Polygon = ({ ...props }: IconProps) => (
  <svg
    width="100"
    height="100"
    viewBox="0 0 100 100"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_188_26565)">
      <circle
        cx="50"
        cy="50"
        r="50"
        fill="#8248E5"
      />
      <path
        d="M78.2421 47.57L65.2585 40.0729C64.1727 39.4467 62.8342 39.4467 61.7484 40.0729L48.7648 47.57L45.2662 49.5922L38.2516 53.6424C37.1658 54.2686 35.8273 54.2686 34.7415 53.6424L27.7269 49.5922C26.6411 48.966 25.969 47.8055 25.969 46.5531V38.4528C25.969 37.2004 26.6354 36.0399 27.7269 35.4137L34.7415 31.3636C35.8273 30.7374 37.1658 30.7374 38.2516 31.3636L45.2662 35.4137C46.352 36.0399 47.0241 37.2004 47.0241 38.4528V43.853L52.9931 40.4061V35.0058C52.9931 33.7534 52.3267 32.593 51.2352 31.9668L38.2516 24.4696C37.1658 23.8435 35.8273 23.8435 34.7415 24.4696L21.7579 31.9668C20.6722 32.593 20 33.7534 20 35.0058V50.0001C20 51.2525 20.6664 52.413 21.7579 53.0392L34.7415 60.5363C35.8273 61.1625 37.1658 61.1625 38.2516 60.5363L51.2352 53.0392L54.7338 51.0169L61.7484 46.9668C62.8342 46.3406 64.1727 46.3406 65.2585 46.9668L72.2731 51.0169C73.3589 51.6431 74.031 52.8036 74.031 54.056V62.1564C74.031 63.4088 73.3646 64.5692 72.2731 65.1954L65.2585 69.2456C64.1727 69.8718 62.8342 69.8718 61.7484 69.2456L54.7338 65.1954C53.648 64.5692 52.9759 63.4088 52.9759 62.1564V56.7561L47.0069 60.2031V65.6033C47.0069 66.8557 47.6733 68.0162 48.7648 68.6424L61.7484 76.1395C62.8342 76.7657 64.1727 76.7657 65.2585 76.1395L78.2421 68.6424C79.3278 68.0162 80 66.8557 80 65.6033V50.6091C80 49.3567 79.3336 48.1962 78.2421 47.57Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="clip0_188_26565">
        <rect
          width="100"
          height="100"
          fill="white"
        />
      </clipPath>
    </defs>
  </svg>
);
